import { Component, HostBinding, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'net-full-spinner',
  templateUrl: './full-spinner.component.html',
  styleUrls: ['./full-spinner.component.scss']
})
export class FullSpinnerComponent {

  @HostBinding('class.active') @Input() active = false;

  constructor() { }
}
